import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/workspace.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/psx-frontend/psx-frontend/components/WorkspaceSplitNavigator.tsx");
